import React from 'react'
import { Link } from 'gatsby'
import { connectStateResults } from 'react-instantsearch-dom'
import { useSelector, useDispatch } from 'react-redux'

import scrollManager from '~/utils/scrollManager'

import trads from '~/intl/trads.json'

import ButtonArrow from '~/components/core/buttonArrow'
import CustomHitsOther from '~/components/features/labo/hitsOther'

import { setCurrentSearchQuery, setHasLaboOpen } from '~/store/actions'

const StateResults = ({ searchResults, searchState, setLaboOpen }) => {
  const lang = useSelector((state) => state.lang)
  const dispatch = useDispatch()
  const hitsLength =
    searchResults !== null
      ? searchResults.hits.filter((hit) => hit.contentType !== 'labo').length
      : 0

  // set timeout otherwise warning in react bad state
  setTimeout(() => {
    dispatch(setCurrentSearchQuery(searchState.query))
  })

  return (
    <>
      {/* only display something if query has 3 or more characters */}
      {searchState.query !== undefined && searchState.query.length >= 3 && (
        <div className="labo__bottom bg-white pt-10 pb-16">
          <div className="fluid-grid">
            <div className="col-12 lg-col-8 mx-auto">
              <p className="title-2-bold text-center mb-8">
                {trads[lang].lab.results}
              </p>

              {hitsLength === 0 && (
                <>
                  <p className="title-block title-block--no-margin text-red text-center">
                    {trads[lang].lab.noResults}
                  </p>
                  <p className="mt-4 text-center font-semibold mb-14">
                    {trads[lang].lab.laboNoResults2}
                  </p>
                </>
              )}

              <CustomHitsOther />

              {hitsLength > 0 && (
                <div className="flex justify-center md:justify-end mt-10 -mx-3 md:mx-0">
                  <Link to={lang === 'fr' ? '/recherche' : '/en/search'}>
                    <ButtonArrow
                      action={() => {
                        dispatch(setHasLaboOpen(false))
                        scrollManager.restart()
                      }}
                      state={{ searchQuery: searchState.query }}
                      text={`${trads[lang].lab.allResults} (${searchResults.nbHits})`}
                      color="purple"
                    />
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const ResultsOther = connectStateResults(StateResults)

export default ResultsOther
